import {getCurrentUser} from 'lib/utils'
import {setPreference} from 'lib/api/currentUser'

const LOCALSTORAGE_KEY = 'preferred_locale'

const selectors = {
  locale: state => state.locale, // IETF locale code, i.e. 'en-US'. Region is optional
  language: state => state.locale.slice(0, 2) // IETF language code, i.e. 'en'
}

const types = [
  'SET_LOCALE'
].reduce((a, k) => ({[k]: `locale/${k}`, ...a}), {})

const localeFromCurrentUser = getCurrentUser().preferences.locale
const localeFromLocalStorage = window.localStorage && window.localStorage.getItem(LOCALSTORAGE_KEY, false)

const defaultLocale = (
  localeFromCurrentUser || localeFromLocalStorage || navigator.language || 'en'
)

const reducer = (localeState = defaultLocale, action = {}) => {
  switch (action.type) {
    case types.SET_LOCALE: {
      return action.meta.locale
    }
    default:
      return localeState
  }
}

const localeImpliesMetricUnits = (locale) => (
  !(locale === 'en-US') // looool
)

const actions = {
  setLocale: (locale) => (dispatch, getState) => {
    dispatch({
      type: types.SET_LOCALE,
      meta: {locale}
    })
    if (getState().currentUser.id) {
      dispatch(setPreference('locale', locale))
      dispatch(setPreference('metric_units', localeImpliesMetricUnits(locale)))
    }
    // persist to localStorage even if persisted to database, so that we
    // remember locale in this browser session if/when the user logs out
    window.localStorage.setItem(LOCALSTORAGE_KEY, locale)
  }
}

export {
  actions as localeActions,
  types as localeTypes,
  reducer as localeReducer,
  selectors as localeSelectors
}
